// sidebarConfig.js
export const sidebarItems = [
    {
      title: "Inicio",
      path: "/inicio",
      icon: "home",
      roles: ["admin", "user", "client","Trafico","Procurement","Documental","Sourcing","Multicuentas","ControlTower","Legal","Propios"], // Roles que pueden ver este elemento
    },
    {
      title: "Configuración",
      path: "/settings",
      icon: "settings",
      roles: ["admin", "user", "client","Trafico","Procurement","Documental","Sourcing","Multicuentas","ControlTower","Legal","Propios"], // Solo el admin puede ver este elemento
    },
    {
      title: "Dashboard Transportista",
      path: "/transportista-dashboard",
      icon: "truck",
      roles: ["transportista", "admin"], // Solo transportistas y admin pueden ver este elemento
    },
    {
      title: "Activity Logs",
      path: "/logs",
      icon: "CodeXml",
      roles:["admin"],
    },
    {
      title: "Órdenes",
      path: "/orders",
      icon: "package",
      roles: ["admin", "user","Procurement","Multicuentas","Propios"], // Admin y user pueden ver este elemento
    },
    {
      title: "Outbound",
      path: "/shipments",
      icon: "truck",
      roles: ["admin", "user","Procurement","Trafico","Multicuentas","Propios"], // Admin y user pueden ver este elemento
    },
    {
      title: "Inbound",
      path: "/inbound",
      icon: "ship",
      roles: ["admin", "user","Procurement","Trafico"], // Admin y user pueden ver este elemento
    },
    {
      title: "Acciones",
      path: "/security",
      icon: "user",
      roles: ["admin","user","Trafico","Multicuentas","Propios"], // Solo el admin puede ver este elemento
    },
    {
      title: "Mesa de control",
      path: "/utr",
      icon: "Warehouse",
      roles:["admin"],
    },
    {
      title: "Auditorías de Calidad",
      path: "/auditorias-calidad",
      icon: "QrCode",
      roles: ["admin"], // Roles que pueden ver este elemento
    },
    //{
    //  title: "Control Vehicular",
    //  path: "/request",
    //  icon: "file-text",
    //  roles: ["admin"], // Admin y user pueden ver este elemento
    //},
    {
      title: "Tracking",
      path: "/tracking",
      icon: "search",
      roles: ["admin", "user","Trafico", "ControlTower","Multicuentas","Propios"], // Todos los roles pueden ver este elemento
    },
    {
      title: "Evidencias",
      path: "/evidences",
      icon: "alert-circle",
      roles: ["admin", "user","Documental","Trafico","Multicuentas","Propios"], // Admin y user pueden ver este elemento
    },
    {
      title: "Costeo",
      path: "/costing",
      icon: "list",
      roles: ["admin","Documental","Multicuentas"], // Solo el admin puede ver este elemento
    },
    {
      title: "Catálogos",
      path: "/catalogo",
      icon: "check-circle",
      roles: ["admin","Procurement"],
    },
    {
      title: "Movimientos Masivos",
      path: "/bulk-movements",
      icon: "plus-circle",
      roles: ["admin","Procurement","Propios"],
    },   
    {
      title: "Flowboard",
      path: "/pool",
      icon: "Activity", 
      roles: ["admin","client"], 
    },
    {
        title: "Ordertracker",
        path: "/Clientview",
        icon: "Waypoints",
        roles: ["admin","client"],
      },
      {
        title: "Reportes",
        path: "/bi-dashboard",
        icon: "ChartBarBig",
        roles: ["admin"],
      },
      {
        title: "Tableros",
        path: "/utilities",
        icon: "ChartSpline",
        roles:["admin", "user","Trafico","Procurement","Documental","Sourcing","Multicuentas","ControlTower","Legal","Propios"],
      },
      {
            title: 'Administracion de Transportistas',
            path: '/transport-admin',
            icon: "LocalShippingIcon",
            roles: ["admin","Sourcing"]
      },
      {
        title: "Torre de control",
        path: "/active-shipments",
        icon: "satellite",
        roles: ["admin", "ControlTower"], 
      },
      {
        title: "Legal",
        path: "/tickets",
        icon: "ticket",
        roles: ["admin","Legal"],
      },
      {
        title: "Anticipos",
        path: "/anticipos",
        icon: "DollarSign",
        roles: ["admin","Propios"],
      },
      {
        title: "Vales de Gasolina",
        path: "/gas-vouchers",
        icon: "Fuel",
        roles: ["admin","Propios"],
      }
  ];